import { FormGroup, InputGroup } from "@blueprintjs/core"
import { useToggle } from "@mantine/hooks"
import CustomButton from "components/Atoms/CustomButton"
import CustomDrawer from "components/Atoms/CustomDrawer"
import Note from "components/Atoms/Note"
import React from "react"
type ExternalReferencesType = {
  data?: any[]
  item?: any
  isOpen?: boolean
  onClose?: any
}

const CopyButton = ({ referenceId }) => {
  const [copied, setCopied] = useToggle()
  return (
    <CustomButton
      unstyled
      onClick={async () => {
        if (copied) return
        await navigator.clipboard.writeText(referenceId)
        setCopied(true)
        setTimeout(() => {
          setCopied(false)
        }, 2500)
      }}
      icon={copied ? "tick" : "duplicate"}
      intent={copied ? "success" : "primary"}
    />
  )
}
const ExternalReferences = ({
  data,
  item,
  isOpen,
  onClose,
}: ExternalReferencesType) => {
  return (
    <CustomDrawer
      icon="third-party"
      title={"External References"}
      isCloseButtonShown
      size={"450px"}
      isOpen={isOpen}
      onClose={onClose}
    >
      <div className="pl-5 pr-3">
        <Note intent="warning" className="my-5">
          The below codes are the identifiers for{" "}
          <span className="font-500">{item?.name}</span> in the respective
          softwares
        </Note>
        {data?.map(item => {
          const referenceId = item.referenceId
          return (
            <FormGroup
              className="mb-5"
              label={<span className="font-500">{item.externalApp.name}</span>}
            >
              <InputGroup
                large
                leftElement={<CopyButton referenceId={referenceId} />}
                value={referenceId}
                readOnly
              />
            </FormGroup>
          )
        })}
      </div>
    </CustomDrawer>
  )
}

export default ExternalReferences
